import { render, staticRenderFns } from "./EducationList.vue?vue&type=template&id=63edf276&scoped=true"
import script from "./EducationList.vue?vue&type=script&lang=js"
export * from "./EducationList.vue?vue&type=script&lang=js"
import style0 from "./EducationList.vue?vue&type=style&index=0&id=63edf276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63edf276",
  null
  
)

export default component.exports